function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".d{fill:#fff;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "a"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "b"
}, /*#__PURE__*/React.createElement("g", {
  id: "c"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M23.93,0h12.69C39.94,0,42.64,2.7,42.64,6.02V24.39H17.9V6.02C17.9,2.7,20.6,0,23.93,0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M43.17,30.1H17.48C7.83,30.1,0,37.93,0,47.58v44.56c0,2.39,1.94,4.33,4.33,4.33H56.32c2.39,0,4.33-1.94,4.33-4.33V47.58c0-9.65-7.83-17.48-17.48-17.48Zm-12.95,48.46c-8.3,0-15.03-6.73-15.03-15.02s6.73-15.03,15.03-15.03,15.03,6.73,15.03,15.03-6.73,15.02-15.03,15.02Z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "d",
  cx: 90.68,
  cy: 30.1,
  r: 6.07
}), /*#__PURE__*/React.createElement("circle", {
  className: "d",
  cx: 72.47,
  cy: 30.1,
  r: 6.07
}), /*#__PURE__*/React.createElement("circle", {
  className: "d",
  cx: 90.68,
  cy: 30.1,
  r: 6.07
}), /*#__PURE__*/React.createElement("circle", {
  className: "d",
  cx: 90.68,
  cy: 48.51,
  r: 6.07
}), /*#__PURE__*/React.createElement("circle", {
  className: "d",
  cx: 90.68,
  cy: 12.19,
  r: 6.07
}), /*#__PURE__*/React.createElement("circle", {
  className: "d",
  cx: 72.47,
  cy: 12.19,
  r: 6.07
}), /*#__PURE__*/React.createElement("circle", {
  className: "d",
  cx: 54.42,
  cy: 12.19,
  r: 6.07
}))));

var SvgGraffitiPlain = function SvgGraffitiPlain(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 96.75 96.46",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGraffitiPlain, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/graffiti-plain.62a16469.svg";
export { ForwardRef as ReactComponent };